<template>
  <!-- Kontener widoku zakresowego filtra -->
  <div class="filter d-flex">
    <!-- Etykieta filtra: tłumaczona nazwa pola -->
    <div class="name">{{ $t(name) }}</div>
    <!-- Symbol operatora dla wartości "od" -->
    <span :class="name === 'Prędkość [km/h]' ? 'symbol2' : 'symbol'">
      {{ t('from').toLowerCase() }}
    </span>
    <!-- Pole wyświetlające wartość minimalną (od) -->
    <input
      :name="fieldFromName"                         
      :value="filtersStore.filters[fieldFromName]"   
      :disabled="true"                             
      type="text"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
    <!-- Symbol operatora dla wartości "do" -->
    <span :class="name === 'Prędkość [km/h]' ? 'symbol2' : 'symbol'">
      {{ t('to').toLowerCase() }}
    </span>
    <!-- Pole wyświetlające wartość maksymalną (do) -->
    <input
      :name="fieldToName"
      :value="filtersStore.filters[fieldToName]"
      :disabled="true"
      type="text"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
  </div>
</template>

<script>
import { useArchivalFiltersStore } from "../../stores/archivalFilters"; // Import store filtrów archiwalnych

export default {
  name: "RangeFilterView", // Nazwa komponentu
  props: ["name", "typeName"], // Właściwości przekazywane przez rodzica

  setup(props) {
    // Inicjalizacja store z filtrami
    const filtersStore = useArchivalFiltersStore();
    
    // Wyodrębnienie bazowej części nazwy pola (bez prefixu min/max)
    const type = props.typeName.slice(3);
    // Zbudowanie kluczy dla minimalnej i maksymalnej wartości
    const fieldFromName = "min" + type;
    const fieldToName = "max" + type;

    // Zwracamy dane do użycia w template
    return { fieldFromName, fieldToName, filtersStore };
  },
};
</script>

<style scoped>
/* Styl nazwy filtra */
.name {
  width: 80px;             /* Szerokość kolumny z nazwą */
  padding: 5px 0;          /* Padding pionowy */
  margin: 5px 5px 5px 0;   /* Margines wokół nazwy */
}

/* Styl standardowego symbolu operatora */
.symbol {
  padding: 10px 5px 0 5px;  /* Padding: top right bottom left */
}

/* Styl symbolu dla prędkości, większy padding w pionie */
.symbol2 {
  padding: 20px 5px 0 5px;
}

/* Styl pola input */
input {
  width: 45px;            /* Szerokość pola wyświetlającego wartość */
  text-align: center;     /* Wyśrodkowanie tekstu */
  padding: 0;             /* Brak paddingu wewnętrznego */
  margin: 5px 0;          /* Margines pionowy */
}
</style>
